export const EMAIL_A_FRIEND_LABELS = {
  vn: {
    modalTitle: "Email ke Teman",
    sharingLabel: "Berbagi:",
    privacyPolicy: "Kebijakan Privasi",
    requiredFields: "*Kolom yang wajib diisi",
    nameLabel: "Nama*",
    emailLabel: "Email*",
    emailCopyHint: "(Kami akan mengirimkan salinan kepada Anda)",
    recipientEmailLabel: "Email Penerima*",
    recipientEmailHint:
      "(Masukkan satu atau lebih alamat email, pisahkan dengan koma.)",
    messageLabel: "Pesan",
    messagePlaceholder: "  Tambahkan Pesan Di Sini",
    sendButton: "Kirim",
    sendingButton: "Mengirim…",
    cancelButton: "Batal",
    closeButton: "Tutup",
    successTitle: "Terima Kasih!",
    successMessage: "Email Anda telah berhasil dikirim.",
    errorName: "Harap masukkan nama Anda",
    errorEmail: "Harap masukkan alamat email Anda",
    errorEmailInvalid: "Harap masukkan alamat email yang valid",
    errorRecipientEmail: "Harap masukkan email penerima",
    errorRecipientEmailInvalid:
      "Harap masukkan alamat email penerima yang valid",
    errorCaptcha: "Harap verifikasi captcha",
    errorCaptchaFailed: "Verifikasi captcha gagal. Silakan coba lagi.",
    errorGeneric: "Ada yang salah. Silakan coba lagi.",
  },
  en: {
    modalTitle: "Email a Friend",
    sharingLabel: "Sharing:",
    privacyPolicy: "Privacy Policy",
    requiredFields: "*Required fields",
    nameLabel: "Name*",
    emailLabel: "Email*",
    emailCopyHint: "(We will send you a copy)",
    recipientEmailLabel: "Recipient(s) Email*",
    recipientEmailHint:
      "(Enter one or more email addresses, separated by a comma.)",
    messageLabel: "Message",
    messagePlaceholder: "  Add Message Here",
    sendButton: "Send",
    sendingButton: "Sending…",
    cancelButton: "Cancel",
    closeButton: "Close",
    successTitle: "SUCCESS",
    successMessage: "Your mail has been sent successfully.",
    errorName: "Please provide your name.",
    errorEmail: "Please provide your email address.",
    errorEmailInvalid:
      "Please enter a valid e-mail address: at least 5 characters and contains an @ and at least one dot.",
    errorRecipientEmail: "Please provide recipient(s) email.",
    errorRecipientEmailInvalid:
      "You must enter a valid email, or comma separate multiple.",
    errorCaptcha: "Please verify the captcha.",
    errorCaptchaFailed: "Captcha verification failed. Please try again.",
    errorGeneric: "Something went wrong. Please try again.",
  },
};
